export default __webpack_public_path__ + "static/media/13.cf21f959.jpeg";